/**
 * Products Grid Footer
 *
 * Simple footer for the Products grid with pagination only.
 * Products are READ-ONLY, so no edit controls are needed.
 */

import { Box } from '@mui/material'
import { GridFooterContainer, GridPagination } from '@mui/x-data-grid-premium'
import React, { ComponentPropsWithoutRef } from 'react'

interface ProductsGridFooterProps extends ComponentPropsWithoutRef<'div'> {
  serverSideMode?: boolean
}

export const ProductsGridFooter: React.FC<ProductsGridFooterProps> = ({ serverSideMode = false }) => {
  return (
    <GridFooterContainer
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
        minHeight: 52,
        overflow: 'hidden',
        px: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, pl: 1 }}>
        {serverSideMode && <GridPagination />}
      </Box>
    </GridFooterContainer>
  )
}

export default ProductsGridFooter
